import { Component, OnInit } from '@angular/core';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.scss']
})
export class RecipesComponent implements OnInit {
  recipe = ContentPage.esES.recipes;
  products: any[] = [];
  currentType: number = 1;
  crumbs: any[]=[];

  constructor(
    private storeservice: ContactService
  ) { }

  ngOnInit() {
    this.setCrumbs();
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.recipe = language == 'esEN' ? ContentPage.esEN.recipes : ContentPage.esES.recipes;
      this.setCrumbs();
    }
    let productsTemp = this.recipe.products.filter((element)=>element.type == 1);
    this.products =  productsTemp;

    if (this.storeservice.getRecipeSelected) {
      console.log('--')
      const data = {
        index: this.storeservice.getRecipeSelected.index,
        type: this.storeservice.getRecipeSelected.type
      }
      this.changeTypeRecipe(data.index, data.type)
    }
  }

  setCrumbs(){
    this.crumbs = this.recipe.crumbs.slice(0,2);
    this.crumbs.push(this.recipe.crumbs[2]);
  }

  changeTypeRecipe(index, type){
    this.currentType = type;
    let productsTemp = this.recipe.products.filter((element)=>element.type == type);
    this.products =  productsTemp;

    this.crumbs = this.recipe.crumbs.slice(0,2);
    this.crumbs.push(this.recipe.crumbs[index+1])

    const tempRecipe = {
      index: index,
      type: type
    }
    this.storeservice.recipeSelected.next(tempRecipe);
  }

}
